import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Switch, Redirect } from "react-router-dom";

import Route from "../Auth/ProtectedRoute";
import Home from "../common/Home";
import ManageChapterFinancialReports from "./ManageChapterFinancialReports";
import FinancialReportForm from "./ManageChapterFinancialReports/FinancialReportForm";
import FinancialReportMailLogView from "./ManageChapterFinancialReports/FinancialReportMailLogView";
import AdminAnalysisReport from "./AnalysisReport";
import ExemptReport from "./ExemptReport";
import IndividualAnalysisReport from "./IndividualAnalysisReport";
import AdminArea from "./AdminArea";
import ManageHelpText from "./AdminArea/ManageHelpText";
import MemberCounts from "./AdminArea/MemberCounts";
import ManageChapterBudgets from "./AdminArea/ManageChapterBudgets";
import ChapterBudgetForm from "./AdminArea/ManageChapterBudgets/ChapterBudgetForm";

import { actionCreators as actionCreatorsAdmin } from "../../_actions/adminActions";

const AdminDashboard = ({ resetIsFetched }) => {
  useEffect(() => {
    resetIsFetched();
  }, []);

  return (
    <Switch>
      <Route path="/admin/home" component={Home} />
      <Route
        exact
        path="/admin/financial-report"
        component={ManageChapterFinancialReports}
      />
      <Route
        exact
        path="/admin/financial-report/:id"
        component={FinancialReportForm}
      />
      <Route
        exact
        path="/admin/financial-report/:id/mail-log"
        component={FinancialReportMailLogView}
      />
      <Route path="/admin/analysis-report" component={AdminAnalysisReport} />
      <Route path="/admin/990-reports" component={ExemptReport} />
      <Route
        path="/admin/individual-analysis-report"
        component={IndividualAnalysisReport}
      />
      <Route
        exact
        path="/admin/settings/help-text"
        component={ManageHelpText}
      />
      <Route
        exact
        path="/admin/settings/member-counts"
        component={MemberCounts}
      />
      <Route
        exact
        path="/admin/settings/chapter-budgets"
        component={ManageChapterBudgets}
      />
      <Route
        exact
        path="/admin/settings/chapter-budgets/:id"
        component={ChapterBudgetForm}
      />
      <Route exact path="/admin/settings" component={AdminArea} />

      <Redirect exact from="/admin" to="/admin/home" />
    </Switch>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actionCreatorsAdmin }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);
